import { UserTypeEnum } from '~shared/constants/user-type.enum';

export namespace UserTypeUtil {
  export function getUserType(registrationType: number): string {
    switch (registrationType) {
      case UserTypeEnum.CONSUMER:
        return 'CONSUMER';
      case UserTypeEnum.METRO_CARD:
        return 'METRO_CARD';
      case UserTypeEnum.DIGITAL:
        return 'DIGITAL';
      case UserTypeEnum.NEW_BUSINESS:
        return 'NEW_BUSINESS';
      default:
        return 'CONSUMER';
    }
  }
}
